const STUDIO_REENTRY_REVIEW_KEY = 'studio:expert-review-reentry';

type NavigationLoadType = 'navigate' | 'reload' | 'back_forward' | 'prerender';

function normalizeHashPath(hash: string): string {
  const normalized = hash.replace(/^#/, '');
  if (!normalized) return '/';

  const [path] = normalized.split('?');
  return path || '/';
}

export function getHashRoutePathFromUrl(urlOrHash: string): string {
  try {
    const parsed = new URL(urlOrHash, window.location.origin);
    return normalizeHashPath(parsed.hash);
  } catch {
    return normalizeHashPath(urlOrHash);
  }
}

export function isStudioRoutePath(path: string): boolean {
  return path === '/studio';
}

export function markStudioReviewReentry(): void {
  sessionStorage.setItem(STUDIO_REENTRY_REVIEW_KEY, '1');
}

export function hasStudioReviewReentry(): boolean {
  return sessionStorage.getItem(STUDIO_REENTRY_REVIEW_KEY) === '1';
}

export function clearStudioReviewReentry(): void {
  sessionStorage.removeItem(STUDIO_REENTRY_REVIEW_KEY);
}

export function consumeStudioReviewReentry(): boolean {
  const shouldRefresh = hasStudioReviewReentry();

  if (shouldRefresh) {
    clearStudioReviewReentry();
  }

  return shouldRefresh;
}

export function getNavigationLoadType(): NavigationLoadType {
  const [entry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[] | [];

  return entry?.type ?? 'navigate';
}
